import { ItemContext } from 'owa-mail-actions/lib/triage/deleteItemsStoreUpdate';
import { isItemOfMessageType } from 'owa-mail-list-store';
import { mailStore } from 'owa-mail-store';
import Message from 'owa-service/lib/contract/Message';

/**
 * Create the item contexts for triage actions that need delete store update
 * @param itemIds of the items that need to be updated in store
 * @returns the item contexts to be used to update the store
 */
export default function createItemContextsForDeleteStoreUpdate(itemIds: string[]): ItemContext[] {
    const itemContexts = itemIds.map(itemIdValue => {
        const item = mailStore.items.get(itemIdValue);
        let isReadValue;

        if (isItemOfMessageType(item)) {
            isReadValue = (item as Message).IsRead;
        } else {
            // Default to isRead = true when not a mail item
            isReadValue = true;
        }

        return {
            itemId: itemIdValue,
            itemConversationId: item.ConversationId,
            isRead: isReadValue,
            mailboxInfo: item.MailboxInfo,
        };
    });

    return itemContexts;
}
